import {createAction} from '@reduxjs/toolkit'
import {getEventId} from '@wix/wix-events-commons-statics'
import {callAPI, createActions} from '../../../../commons/actions/data-action-helper'
import {openDialogModal} from '../../../../commons/services/modal'
import {getEvent, isDemoEvent} from '../selectors/event'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState} from '../types/state'

export const GET_POLICIES_OLD = createActions('GET_POLICIES_OLD')
export const TOGGLE_AGREE_POLICIES_OLD = 'TOGGLE_AGREE_POLICIES_OLD'

export const toggleAgreePoliciesOld = () => ({
  type: TOGGLE_AGREE_POLICIES_OLD,
})

export const toggleAgreePolicies = createAction('TOGGLE_AGREE_POLICIES')

export const getPoliciesOld =
  ({showAlert}: {showAlert: boolean}) =>
  (dispatch: Function, getState: GetState) => {
    const state = getState()
    if (!isDemoEvent(state)) {
      const event = getEvent(state)
      return dispatch(callAPI(GET_POLICIES_OLD, getEventId(event), {showAlert}))
    }
  }

export const getPolicies = createAsyncAction<
  {policies: wix.events.Policy[]; policyAgreementToken?: string},
  {showAlert: boolean}
>(
  'GET_POLICIES',
  async (_, {getState, extra: {serverApi}}) => {
    const state = getState()
    const event = getEvent(state)

    return serverApi.getPolicies(getEventId(event))
  },
  {
    condition: (_, {getState}) => {
      return !isDemoEvent(getState())
    },
  },
)

interface OpenPolicyModalArgs {
  policyId: string
  returnFocusElement: string
}
export const openPolicyModal =
  ({policyId, returnFocusElement}: OpenPolicyModalArgs) =>
  (dispatch: Function, getState: GetState) => {
    const state = getState()
    const event = getEvent(state)
    dispatch(
      openDialogModal({
        type: 'policy',
        params: {
          policyId,
          eventId: getEventId(event),
        },
        returnFocusElement,
      }),
    )
  }
